import { format } from "date-fns";
import React from "react";
import { useAppSelector } from "../../../../store";
import News from "./components/News";
import style from "./style.module.scss";

const FreshNews = () => {
  const freshNews = useAppSelector((state) => state.news.client.freshNews);
  return (
    <div className={style.wrapper}>
      {freshNews.map((i, idx) => {
        return (
          <News
            date={format(new Date(i.date), "dd.MM.yyyy")}
            description={i.shortDescription}
            id={i._id}
            position={idx + 1}
            src={i.imgSrc}
            title={i.title}
            key={i._id}
          />
        );
      })}
    </div>
  );
};

export default FreshNews;
